import { render, staticRenderFns } from "./c-tabs.vue?vue&type=template&id=a157c51a"
import script from "./c-tabs.vue?vue&type=script&lang=js"
export * from "./c-tabs.vue?vue&type=script&lang=js"
import style0 from "./c-tabs.vue?vue&type=style&index=0&id=a157c51a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports